module.exports = __webpack_public_path__ + "static/img/poster_sl04.3f798aba.jpg";